import React, {Component, PropTypes} from "react";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";

import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";
import {toast} from "react-toastify";
import {css} from "glamor";
import FormFieldValidationError from "../../Common/FormFieldValidationError/FormFieldValidationError";

class EditProductionCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            productBarcode: "",
            productBarcodeError: '',
        };
        this.validateSagawaCode= this.validateSagawaCode.bind(this);
        this.saveProductBarcode=this.saveProductBarcode.bind(this);
    }

    handleClose = () => {
        this.setState({show: false});
    };

    handleShow = () => {
        this.setState({
            show: true,
        });
    };

    validateSagawaCode = () => {
        // console.log("validate sagawa code",this.state.productBarcode);
        let sagawaCode = this.state.productBarcode;
        let valid = 1;
       if(sagawaCode.length!==14) {
            valid = 2
        }
        return valid;
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            productBarcodeError: ''
        });
    };
    saveProductBarcode() {

        let productBarcodeError = "";
        let validationPassed = true;
        let valid = this.validateSagawaCode();
        if (valid === 0) {
            validationPassed = false;
            productBarcodeError = "app.validation.production-barcode.invalid-barcode";

        }
        if (valid === 2) {
            validationPassed = false;
            productBarcodeError = "app.validation.production-barcode.invalid-barcode-length";

        }
        // console.log("bar",this.state.productBarcode);
        // console.log("OOOOOOOO",this.props.order);
        if (valid === 1) {
            // console.log("post", postData);
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*'
                }
            };

            axios.post(RESOURCE_BASE_URL + 'api/orders/productBarcode',
                {
                    barcode: this.props.barcode,
                    itemId: this.props.orderItemId,
                    orderId: this.props.orderId,
                    productBarcode: this.state.productBarcode
                }, axiosConfig)
                .then((res) => {

                    this.props.getAllProduction();
                    this.setState({show:false})
                    toast("佐川のバーコード番号が正常に保存されました。", {
                        className: css({
                            background: "#96d146 !important",
                            padding: "30px",
                            color: "black !important"
                        })
                    });
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                    toast("佐川バーコード番号の保存に失敗しました。", {
                        className: css({
                            background: "#db4f64 !important",
                            padding: "30px",
                            color: "black !important",
                            width :'400px',
                        })
                    });
                });
        } else {
            this.setState({productBarcodeError});
        }
    }
    render() {
        return(
            <span>
            <a className="btn btn-primary btn-xs" id="product-code-edit" onClick={this.handleShow}>
                編集
            </a>
        <Modal show={this.state.show} onHide={this.handleClose} >
            <Modal.Header closeButton>
                佐川番号を更新する
            </Modal.Header>
            <Modal.Body>
                <div className="text-align-center">
                <label>
                    アイテム {this.props.generatedBarcode} に新しい佐川番号を追加

                </label>
                <input type="text"
                       id="barcode-input-edit"
                       className="form-control input-md "
                       value={this.state.productBarcode}
                       name="productBarcode"
                       onChange={this.onInputChange}


                />
                <FormFieldValidationError errors={this.state.productBarcodeError}/>
                </div>
            </Modal.Body>
            <Modal.Footer>

                        <button className="btn btn-success" onClick={this.saveProductBarcode}>
                            保存
                        </button>
                        <button className="btn btn-primary" onClick={this.handleClose}>
                            キャンセル
                        </button>

            </Modal.Footer>
        </Modal>
        </span>
        )
    }

}
export default EditProductionCode;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/EditProductionCode.js